import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork, disableNetwork } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  // Optional GA4 measurement ID so Firebase can link analytics properly when provided
  measurementId: process.env.VUE_APP_GA_MEASUREMENT_ID || undefined,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize database with offline support
const initializeDatabase = async (): Promise<void> => {
  try {
    // Firestore automatically enables offline persistence in modern versions
    // We can manually control network state if needed
    console.log('Firestore initialized with automatic offline persistence');
  } catch (error: unknown) {
    console.error('Error initializing Firestore:', error);
  }
};

// Network control functions for offline/online handling
export const goOffline = () => disableNetwork(db);
export const goOnline = () => enableNetwork(db);

// Initialize database
initializeDatabase().catch(console.error);

export default app;